export { DesignTokenDocBlock } from "./doc-blocks";

// make it work with --isolatedModules
export default {};
